import {
  EventEmitter
} from "events";
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'

class SkillsService extends EventEmitter {

  SKILLS_BASE_URL = "http://192.168.255.58/";
  TC_API_BASE_URL = process.env.VUE_APP_API_URL + "/";
  INDEX_NAME = process.env.VUE_APP_INDEX_NAME + "/";
  INAME = process.env.VUE_APP_INDEX_NAME;

  CONTENT_EDIT_SEARCH_INDEX = "demobackend-audit-trail";
  TIMESHEETS_SEARCH_INDEX = "corporate-timesheets";

  search() {
    return TCVelikClient.GetRelative("skillz/_search?size=10000");
  }

  logScore(AccountId, SkillId, CreatedBy, CreatedFor, Comment, Score, ScoreType) {
    return TCVelikClient.PostRelative("api/Skill/LogScores", {
      AccountId: AccountId ? AccountId : TCVelikClient.getSelectedAccountId(),
      SkillId: SkillId,
      CreatedBy: CreatedBy,
      CreatedFor: CreatedFor,
      Comment: Comment,
      Score: Score,
      ScoreType: ScoreType
    });
  }

  getAccountSkillsStats(from, to) {
    return TCVelikClient.PostRelative("api/Skill/GetAccountSkillsStats", {
      from: from,
      to: to
    });
  }

  getAutoCompleteData() {
    var query = {
      "aggs": {
        "By_Language": {
          "terms": {
            "field": "languagena.keyword",
            "order": {
              "_count": "desc"
            },
            "size": 50000
          }
        },
        "By_Project": {
          "terms": {
            "field": "projecttitle.keyword",
            "order": {
              "_count": "desc"
            },
            "size": 50000
          }
        },
        "By_SyntaxType": {
          "terms": {
            "field": "syntaxtype.keyword",
            "order": {
              "_count": "desc"
            },
            "size": 50000
          },
          "aggs": {
            "Languages": {
              "terms": {
                "field": "languagena.keyword"
              }
            }
          }
        },
        "By_Tag": {
          "nested": {
            "path": "project"
          },
          "aggs": {
            "Tags": {
              "terms": {
                "field": "project.tag.title.keyword",
                "order": {
                  "_count": "desc"
                },
                "size": 50000
              }
            }
          }
        },
        "By_Developer": {
          "nested": {
            "path": "developers"
          },
          "aggs": {
            "Developers": {
              "terms": {
                "field": "developers.authorEmail.keyword",
                "order": {
                  "_count": "desc"
                },
                "size": 50000
              }
            }
          }
        }
      },
      "size": 0
    };

    var request = {
      query: query,
      indexEndpoint: "_search"
    }

    var url = "/api/query/PostElasticQuery";
    return TCVelikClient.PostRelative(url, request);

  }

  searchPhrase(phrase, page, pageSize) {
    var query = {
      "query": {
        "bool": {
          "must": [{
            "wildcard": {
              "rawTextKeyword": {
                "value": "*" + phrase.toLowerCase() + "*"
              }
            }
          },
          {
            "term": {
              "syntaxtype.keyword": {
                "value": "FullContents"
              }
            }
          }
          ]
        }
      },
      "highlight": {
        "fields": {
          "rawTextKeyword": {
            "number_of_fragments": 10,
            "pre_tags": ["<TCV__HIGHLIGHT class='bg-success text-white'>"],
            "post_tags": ["</TCV__HIGHLIGHT>"],
            "options": {
              "return_offsets": true
            },
            "fragment_size": 150
          },
        }
      },
      "_source": ["accountid", "projecttitle", "projectid", "syntaxtype", "relativeFileName", "languagena", "changes", "lastCommitId"],
      "from": ((page - 1) * pageSize),
      "size": pageSize,
      "sort": {
        "changes": {
          "order": "desc"
        }
      },
      "aggs": {
        "languages": {
          "terms": {
            "field": "languagena.keyword",
            "size": 1000
          }
        },
        "projects": {
          "terms": {
            "field": "projecttitle.keyword",
            "size": 1000
          }
        },
        "type": {
          "terms": {
            "field": "syntaxtype.keyword"
          }
        }
      },
    };

    var request = {
      query: query,
      indexEndpoint: "_search"
    }

    var url = "/api/query/PostElasticQuery";
    return TCVelikClient.PostRelative(url, request);
  }

  loadOrphanProjects() {
    return TCVelikClient.GetRelative("/api/Skill/GetOrphans")
  }

  renewAllSkills() {
    return TCVelikClient.PostRelative("/api/Skill/ResetCache");
  }

  searchProjectPhrase(phrase, page, pageSize, projectId) {
    var query = {
      "query": {
        "bool": {
          "must": [{
            "wildcard": {
              "rawTextKeyword": {
                "value": "*" + phrase.toLowerCase() + "*"
              }
            }
          },
          {
            "term": {
              "syntaxtype.keyword": {
                "value": "FullContents"
              }
            }
          },
          {
            "term": {
              "projectid.keyword": {
                "value": "" + projectId + ""
              }
            }
          }
          ]
        }
      },
      "highlight": {
        "fields": {
          "rawTextKeyword": {
            "number_of_fragments": 10,
            "pre_tags": ["<TCV__HIGHLIGHT class='bg-success text-white'>"],
            "post_tags": ["</TCV__HIGHLIGHT>"],
            "options": {
              "return_offsets": true
            },
            "fragment_size": 150
          },
        }
      },
      "_source": ["accountid", "projecttitle", "projectid", "syntaxtype", "relativeFileName", "languagena", "changes", "lastCommitId"],
      "from": ((page - 1) * pageSize),
      "size": pageSize,
      "sort": {
        "changes": {
          "order": "desc"
        }
      }
    };

    var request = {
      query: query,
      indexEndpoint: "_search"
    }

    var url = "/api/query/PostElasticQuery";
    return TCVelikClient.PostRelative(url, request);
  }

  searchAnythingQuery(query, indexesToSearch, page, pageSize, dateFrom, dateTo) {
    pageSize = pageSize ? pageSize : 100;

    dateFrom = dateFrom || new Date(Date.UTC(1980, 0, 1, 0, 0, 0));
    dateTo = dateTo || new Date(Date.UTC(2200, 0, 1, 23, 59, 59));

    var queryToRun = {
      "query": {
        "bool": {
          "must": [{
            "query_string": {
              "query": query
            }
          },
          {
            "bool": {
              "filter": [{
                "script": {
                  "script": {
                    "source": `
                          def date = ${this.generateCommonDateFieldPainlessScript(indexesToSearch)}
                          return date >= Instant.parse('${dateFrom.toISOString()}').toEpochMilli();
                        `,
                    "lang": "painless"
                  }
                }
              },
              {
                "script": {
                  "script": {
                    "source": `
                          def date = ${this.generateCommonDateFieldPainlessScript(indexesToSearch)}
                          return date <= Instant.parse('${dateTo.toISOString()}').toEpochMilli();
                        `,
                    "lang": "painless"
                  }
                }
              }
              ]
            }
          }
          ]
        }
      },
      "from": ((page - 1) * pageSize),
      "size": pageSize,
      "sort": [{
        "_script": {
          "type": "number",
          "script": {
            "lang": "painless",
            "source": this.generateCommonDateFieldPainlessScript(indexesToSearch)
          },
          "order": "desc"
        }
      }],
      "script_fields": {
        "document_date": {
          "script": {
            "lang": "painless",
            "source": this.generateCommonDateFieldPainlessScript(indexesToSearch)
          }
        }
      },
      _source: true,
      "aggs": {
        "ByType": {
          "terms": {
            "field": "_index",
            "size": 1000
          }
        },
        "ByContentType": {
          "terms": {
            "field": "itemType.keyword",
            "size": 1000
          },
          "aggs": {
            "ByStatus": {
              "terms": {
                "field": "eventType.keyword",
                "size": 1000
              },
            }
          }
        }
      }
    };

    var request = {
      query: queryToRun,
      indexEndpoint: "_search",
      indexes: indexesToSearch.map((itm) => itm.Value).join()
    };

    var url = "/api/query/PostElasticQueryMulti";
    return TCVelikClient.PostRelative(url, request);
  }

  async getContentEdit(userEmail) {
    var searchPhrase = userEmail;
    var indexInfo = this.getSearchIndexes().filter(i => i.Value == this.CONTENT_EDIT_SEARCH_INDEX);

    var dateFrom = new Date();
    dateFrom.setHours(0, 0, 0, 0);

    var dateTo = new Date();
    dateTo.setHours(23, 59, 59, 999);

    var result = await this.searchAnythingQuery(searchPhrase, [...indexInfo], 1, 250, dateFrom, dateTo);

    var dataFinal = result.data.hits.hits.map(function (item) {
      var title = "";
      var activity = "";

      if (item._source.itemTitle) {
        title = item._source.itemTitle;
        activity = "Content Edit";
      }
      else if (item._source.roleName){
        title = item._source.roleName;
        activity = "Administration";
      }
      else if (item._source.configName){
        title = item._source.configName;
        activity = "Administration";
      }
      else if (item._source.loginResult){
        title = "Logging in to the system",
        activity = "Administration"
      }
      else if (item._source.sfUserUsername){
        title = "User " + item._source.sfUserUsername + " " + JSON.stringify(item._source.eventTags),
        activity = "Administration"
      }

      return {
        Title: title,
        Activity: activity,
        Type: item._source.itemType,
        Action: item._source.eventType,
        Url: item._source.itemUrl,
        Id: item._source.itemId,
        TimeStamp: item._source.timestamp
      }
    });

    return dataFinal;
  }

  async getTimeSheets(userEmail) {
    var searchPhrase = userEmail;
    var indexInfo = this.getSearchIndexes().filter(i => i.Value == this.TIMESHEETS_SEARCH_INDEX);

    var dateFrom = new Date();
    dateFrom.setHours(0, 0, 0, 0);

    var dateTo = new Date();
    dateTo.setHours(23, 59, 59, 999);

    var result = await this.searchAnythingQuery(searchPhrase, [...indexInfo], 1, 10, dateFrom, dateTo);

    var dataFinal = result.data.hits.hits.map(function (item) {
      return {
        Title: item._source.itemTitle,
        Type: item._source.itemType,
      }
    });

    return dataFinal;
  }

  searchQuery(query, page, pageSize) {
    var finalQuery = {
      "query": query,
      "highlight": {
        "fields": {
          "rawTextKeyword": {
            "number_of_fragments": 10,
            "pre_tags": ["<TCV__HIGHLIGHT class='bg-success text-white'>"],
            "post_tags": ["</TCV__HIGHLIGHT>"],
            "options": {
              "return_offsets": true
            },
            "fragment_size": 150,
            "type": "unified",
            "force_source": true
          },
        }
      },
      "_source": ["accountid", "developers", "projecttitle", "projectid", "syntaxtype", "relativeFileName", "languagena", "start", "end", "changes", "lastCommitId"],
      "from": ((page - 1) * pageSize),
      "size": pageSize,
      "sort": {
        "changes": {
          "order": "desc"
        }
      },
      "aggs": {
        "languages": {
          "terms": {
            "field": "languagena.keyword",
            "size": 1000
          }
        },
        "projects": {
          "terms": {
            "field": "projecttitle.keyword",
            "size": 1000
          }
        },
        "type": {
          "terms": {
            "field": "syntaxtype.keyword"
          }
        }
      },
    };

    var request = {
      query: finalQuery,
      indexEndpoint: "_search"
    }

    var url = "/api/query/PostElasticQuery";
    return TCVelikClient.PostRelative(url, request);
  }

  generateCommonDateFieldPainlessScript(indices) {
    var scriptParts = indices.map((index) => {
      return "doc['_index'].value == '" + index.Value + "' && doc['" + index.DateFieldName + "'].size() > 0 ? doc['" + index.DateFieldName + "'].value.getMillis() : ";
    });

    // Add a default case for indices not in the array
    scriptParts.push('0');

    var scriptSource = scriptParts.join('') + ';';

    return `${scriptSource}`;
  }


  searchSkill(skillId, page, pageSize, projectName) {
    return new Promise((success) => {
      this.getSkillById(skillId).then(function (response) {
        try {
          JSON.parse(response.data.SkillQuery).query;
        } catch (err) {
          alert("The query for the skill \"" + response.data.SkillName + "\" is not valid. \nPlease ensure it contains valid query and try again.\nError was: " + err);
        }

        var query = JSON.parse(response.data.SkillQuery).query;

        if (projectName &&
          projectName.length > 0 &&
          query &&
          query.bool &&
          query.bool.must &&
          query.bool.must.length > 0) {
          query.bool.must.push({
            term: {
              "projecttitle.keyword": projectName
            }
          });
        }

        var finalQuery = {
          "query": query,
          "highlight": {
            "fields": {
              "rawTextKeyword": {
                "number_of_fragments": 10,
                "pre_tags": ["<TCV__HIGHLIGHT class='bg-success text-white'>"],
                "post_tags": ["</TCV__HIGHLIGHT>"],
                "options": {
                  "return_offsets": true
                },
                "fragment_size": 150,
                "type": "unified",
                "force_source": true
              },
            }
          },
          "_source": ["accountid", "projecttitle", "projectid", "syntaxtype", "relativeFileName", "languagena", "start", "end", "changes", "lastCommitId"],
          "from": ((page - 1) * pageSize),
          "size": pageSize,
          "sort": {
            "changes": {
              "order": "desc"
            }
          }
        };

        var request = {
          query: finalQuery,
          indexEndpoint: "_search"
        }

        // var a = this.TC_API_BASE_URL;
        var url = "/api/query/PostElasticQuery";
        TCVelikClient.PostRelative(url, request).then(function (dta) {
          success(dta);
        });
      });
    });
  }

  getCatgoryById(id) {
    var url = "/api/Skill/GetSkillCategoryById?id=" + id;
    return TCVelikClient.GetRelative(url);
  }

  getSkillById(id) {
    var url = "/api/Skill/GetSkillById?id=" + id;
    return TCVelikClient.GetRelative(url);
  }

  getSkillByIdCalculated(id, forUser) {

    var url = "/api/Skill/GetSkillByIdCalculated?id=" + id;
    if (forUser && forUser.length > 0)
      url += "&forUser=" + forUser
    return TCVelikClient.GetRelative(url);
  }

  reorder(initialParentId, targetParentId, movedObjectId, movedObjectType, oldIndex, newIndex) {
    var url = "/api/Skill/Reorder";
    var query = {
      FromCategoryId: initialParentId,
      ToCategoryId: targetParentId,
      ObjectId: movedObjectId,
      ObjectOldIndex: oldIndex,
      ObjectNewIndex: newIndex,
      ObjectType: movedObjectType
    };

    return TCVelikClient.PostRelative(url, query);
  }

  saveCategory(categoryObject) {
    var url = "/api/Skill/SaveCategory";
    var query = categoryObject;
    return TCVelikClient.PostRelative(url, query);
  }

  saveSkill(skillObject) {
    var url = "/api/Skill/SaveSkill";
    var query = skillObject;
    return TCVelikClient.PostRelative(url, query);
  }

  updateSkillProperty(skillId, skillPropertyName, skillPropertyNewValue) {
    var url = "/api/Skill/PatchProperty";
    var query = {
      Id: skillId,
      PropertyName: skillPropertyName,
      PropertyValue: skillPropertyNewValue
    };

    return TCVelikClient.PostRelative(url, query);
  }

  getCategory(id) {
    var url = "/api/Skill/GetSkillCategoryById?id=" + id;
    return TCVelikClient.GetRelative(url);
  }

  getCategories(forParent) {
    var url = "/api/Skill/GetCategories";
    var query = {};

    if (forParent && forParent > 0) {
      query.Parent = forParent
    }
    return TCVelikClient.PostRelative(url, query);
  }

  getCategoryLinkForUser(tracks, categories, userId) {
    var filters = {
      tracks: tracks,
      categories: categories
    };

    return "/dashboard/people/" + userId + "/details?filter=" + encodeURIComponent(JSON.stringify(filters));
  }

  getSkillLinkForUser(skillId, userId) {
    return `/dashboard/skill-details/${skillId}?forUser=${userId}`;
  }

  deleteCategory(categoryId) {
    var url = "/api/Skill/DeleteCategory?id=" + categoryId;
    return TCVelikClient.PostRelative(url, null);
  }

  GetSkillWithBreadCrumbs() {
    return TCVelikClient.GetRelative("/api/Skill/GetSkillWithBreadCrumbs");
  }

  deleteSkill(skillId) {
    var url = "/api/Skill/DeleteSkill?id=" + skillId;
    return TCVelikClient.PostRelative(url, null);
  }

  getAllSkillsInCategory(category) {
    var catQuery = {
      "query": {
        "bool": {
          "must": {
            "wildcard": {
              "category.keyword": category + "*"
            }
          }
        }
      },
      "sort": [{
        "category.keyword": {
          "order": "asc"
        },
      },
      {
        "categoryOrder.keyword": {
          "order": "asc"
        }
      }
      ]
    };

    return TCVelikClient.PostRelative("/api/query/PostElasticSearchQuery", {
      query: catQuery,
      indexEndpoint: "_search"
    });
  }

  getFeatureOwnershipView() {

  }

  getMainStats(projectId, user) {
    var query = {
      "Project": projectId,
      "User": user
    }
    return TCVelikClient.PostRelative("/api/Query/GetAllSkills", query);
  }

  getSearchIndexes() {
    // Hack to fix later:

    var isDevelopment = false; // window.location.host.startsWith("localhost");

    return [{
      Name: "Commits",
      Value: "code-commit-history-tcvelik-" + (isDevelopment ? "developer" : "prod"),
      Selected: true,
      DateFieldName: "AuthorDateStrictISO"
    },
    {
      Name: "Source code",
      Value: "codeinsights" + (isDevelopment ? "-developer" : ""),
      Selected: false,
      DateFieldName: "lastCommitDate"
    },
    {
      Name: "Code Annotations",
      Value: "tcembed-tcvelik-" + (isDevelopment ? "developer" : "prod"),
      Selected: true,
      DateFieldName: "lastUpdatedOn"
    },
    {
      Name: "Scoring events",
      Value: "tcskillscore-tcvelik-" + (isDevelopment ? "developer" : "prod"),
      Selected: true,
      DateFieldName: "lastUpdatedOn"
    },
    {
      Name: "Skills",
      Value: "tcskill-tcvelik-" + (isDevelopment ? "developer" : "prod"),
      Selected: true,
      DateFieldName: "lastUpdatedOn"
    },
    {
      Name: "Timesheets",
      Value: "corporate-timesheets",
      Selected: true,
      DateFieldName: "Time"
    },
    {
      Name: "Content editing",
      Value: "demobackend-audit-trail",
      Selected: true,
      DateFieldName: "timestamp"
    },
    {
      Name: "Any Post",
      Value: "tcpost-tcvelik-" + (isDevelopment ? "developer" : "prod"),
      Selected: false,
      DateFieldName: "lastUpdatedOn"
    }
    ];
  }
}

export default new SkillsService();
